export default __webpack_public_path__ + "static/media/storageUnit1-afterA-2048w.a637d4ad.png";